/**
 * FRE-143 D9: merges a server playlist's tab ids with the local copy it replaces. Local tab ids that are still
 * queued for upload (`isPending`) and missing from the server list are re-inserted at `min(oldIndex, length)`.
 * `preserved` tells the caller that the playlist differs from the server again and must be pushed.
 */
export function mergePendingTabIds(
  serverIds: readonly string[],
  localIds: readonly string[],
  isPending: (tabId: string) => boolean
): { ids: string[]; preserved: boolean } {
  const ids = [...serverIds];
  let preserved = false;
  localIds.forEach((id, oldIndex) => {
    if (ids.includes(id) || !isPending(id)) return;
    ids.splice(Math.min(oldIndex, ids.length), 0, id);
    preserved = true;
  });
  return { ids, preserved };
}
